import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from 'react';
import LoadingNavBar from '../../components/navbar/LoadingNavBar';
import OfflineComponent from '../../components/utils/OfflineComponent';

const ConnectivityContext = createContext();

export const ConnectivityProvider = ({ children }) => {
  
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [lastOfflineTime, setLastOfflineTime] = useState(null);
  const isOnlineRef = useRef(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      isOnlineRef.current = true;
    };

    const handleOffline = () => {
      setIsOnline(false);
      isOnlineRef.current = false;
      setLastOfflineTime(new Date());
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const value = {
    isOnline,
    isOnlineRef,
    lastOfflineTime,
  };

  if (!isOnlineRef.current) {
    return (
      <>
        <LoadingNavBar />
        <OfflineComponent />
      </>
    );
  }

  return (
    <ConnectivityContext.Provider value={value}>
      {children}
    </ConnectivityContext.Provider>
  );
};

export const useConnectivity = () => {
  const context = useContext(ConnectivityContext);
  if (context === undefined) {
    throw new Error(
      'useConnectivity must be used within a ConnectivityProvider',
    );
  }
  return context;
};
